export default __webpack_public_path__ + "static/media/onboard_logo.98378c3d.png";